import { Injectable, Input } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable, of, Subject } from 'rxjs';
import * as jwt_decode from 'jwt-decode';
import { Perfil } from 'src/app/Models/Menu/menu';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class BackOfficeSession {
    public url: string;
    public idUsuario: number;

    // tslint:disable-next-line: variable-name
    constructor(private _http: HttpClient, public jwtHelper: JwtHelperService) {
        this.url = environment.urlAddressAuthentication;
    }

    login(email: string, password: string) {
        return this._http.post(environment.urlAddressAuthentication + 'login', { usuario:email, contrasena: password }, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            })
        });
    }

    obtenerInfoComercio(comercioID) {
        const token = sessionStorage.getItem('token');
        return this._http.get<Perfil>(environment.urlAddressAuthentication + 'info/' +  comercioID, {
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json'
            })
        });
    }


    cambioPassword(passwordAnterior: string, passwordNueva: string) {
        const token = sessionStorage.getItem('token');
        const usuarioID = sessionStorage.getItem('usuarioID');

        return this._http.put(environment.urlAddressAuthentication + 'cambiarClave', {
            usuarioID,
            password: passwordAnterior,
            passwordNueva
        },
            {
                headers: new HttpHeaders({
                    Authorization: 'Bearer ' + token,
                    'Content-Type': 'application/json'
                })
            });
    }


    recuperarPassword(email: string) {
        return this._http.post(environment.urlAddressAuthentication + 'recuperarClave', { email },
            {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json'
                })
            });
    }

    public isAuthenticated(): boolean {
        const token = sessionStorage.getItem('token');
        return !this.jwtHelper.isTokenExpired(token);
    }


    getMenu(): Observable<Perfil> {
        const token = sessionStorage.getItem('token');
        const usuarioID = sessionStorage.getItem('usuarioID');
        return this._http.get<Perfil>(environment.urlAddressAuthentication + 'menu/' + usuarioID, {
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json'
            })
        });
    }

    getTabs(): Observable<Perfil> {
        const token = sessionStorage.getItem('token');
        const PerfilID = sessionStorage.getItem('perfilID');
        return this._http.get<Perfil>(environment.urlAddressAuthentication + 'menu/obtenerTabs/' + PerfilID, {
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json'
            })
        });
    }

   
}
